import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ProfileFacade } from '@app/store/profile';
import { SessionFacade } from '@app/store/session';
import { AccountFacade } from '@corelabs/angular/account';
import { filter, map, tap } from 'rxjs';

export const logout = (): CanActivateFn => {
    return () => {
        const sessionFacade = inject(SessionFacade);
        const profileFacade = inject(ProfileFacade);
        const accountFacade = inject(AccountFacade);

        accountFacade.logout();

        return accountFacade.loggedOut$.pipe(
            filter((loggedOut) => loggedOut !== null),
            tap(() => {
                sessionFacade.clear();
                profileFacade.clear();
            }),
            map(() => true),
        );
    };
};
